var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_318_542)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1058 3.51417L12.0833 0.614166C11.4495 0.249684 10.7312 0.0578651 10 0.0578651C9.26885 0.0578651 8.5505 0.249684 7.91667 0.614166L2.89417 3.51417C2.26157 3.88076 1.73623 4.40694 1.37065 5.04013C1.00507 5.67332 0.812033 6.39135 0.810837 7.1225V12.9225C0.812055 13.6538 1.00509 14.3719 1.37066 15.0052C1.73624 15.6385 2.26156 16.1649 2.89417 16.5317L7.91667 19.4308C8.55041 19.7956 9.2688 19.9875 10 19.9875C10.7312 19.9875 11.4496 19.7956 12.0833 19.4308L17.1058 16.5317C17.7385 16.1649 18.2638 15.6385 18.6293 15.0052C18.9949 14.3719 19.188 13.6538 19.1892 12.9225V7.1225C19.188 6.39135 18.9949 5.67332 18.6294 5.04013C18.2638 4.40694 17.7384 3.88076 17.1058 3.51417ZM8.75 2.05833C9.13005 1.83891 9.56116 1.7234 10 1.7234C10.4388 1.7234 10.87 1.83891 11.25 2.05833L16.2725 4.9575C16.3999 5.038 16.5195 5.13005 16.63 5.2325L11.4692 8.21167C11.0224 8.46923 10.5157 8.60481 10 8.60481C9.48429 8.60481 8.97763 8.46923 8.53084 8.21167L3.37 5.2325C3.48048 5.13005 3.60015 5.038 3.7275 4.9575L8.75 2.05833ZM3.7275 15.0875C3.34767 14.8674 3.0323 14.5515 2.81293 14.1712C2.59356 13.791 2.4779 13.3598 2.4775 12.9208V7.1225C2.48329 6.97237 2.5031 6.82311 2.53667 6.67667L7.6975 9.65583C8.15329 9.9151 8.65025 10.0941 9.16667 10.185V18.1592C9.02272 18.1151 8.88323 18.0576 8.75 17.9875L3.7275 15.0875ZM17.5225 12.9208C17.5221 13.3598 17.4064 13.791 17.1871 14.1712C16.9677 14.5515 16.6523 14.8674 16.2725 15.0875L11.25 17.9875C11.1168 18.0576 10.9773 18.1151 10.8333 18.1592V10.185C11.3498 10.0941 11.8467 9.9151 12.3025 9.65583L17.4633 6.67667C17.4969 6.82311 17.5167 6.97237 17.5225 7.1225V12.9208Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_318_542"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "black"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCube);
export default __webpack_public_path__ + "static/media/Cube.a09d78ecb5b916da5685e8f546b3708c.svg";
export { ForwardRef as ReactComponent };